module.exports = __webpack_public_path__ + "img/news1.b7070f76.svg";